import { AnyAction, bindActionCreators, Dispatch } from 'redux';
import { BorderGridContainer, GridBox } from '@ahmdigital/ui';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash/fp';
import React, { useEffect } from 'react';

import { PAGE_TITLE_TEMPLATE } from '../../ahm-constants/ui';
import { VARIANT } from '../../components/offers/tile/constants';
import getContentToRender from '../explained-term/detail/utils/get-content-to-render';
import Head from '../../../utils/head';
import MeetTheTeam from './components/meet-the-team';
import OfferTile from '../../components/offers/tile';
import ReferralActions from '../../actions/referral';
import ReferrerActions from '../../actions/referrer';
import type { ItemType } from '../home/components/content-tiles/utils/map-content';
import type { Offer, Placeholder } from '../../components/offers/types';

type OffersProps = {
  actions: {
    referral: {
      reset: () => void;
    };
    referrer: {
      setHasPartnerReferrer: (hasPartnerReferrer?: boolean) => void;
    };
  };
  activeOffers: Offer[];
  pageContent: {
    item: ItemType;
  }[];
  placeholders: Placeholder[];
};

const Offers = ({ actions, activeOffers, pageContent, placeholders }: OffersProps) => {
  useEffect(() => {
    actions.referral.reset();
    actions.referrer.setHasPartnerReferrer(false);
  }, [actions.referral, actions.referrer]);

  const tableOfContents = pageContent?.map((entry) => entry.item);

  return (
    <>
      <Head titleTemplate={PAGE_TITLE_TEMPLATE}>
        <title>Private health insurance deals & offers</title>
        <meta
          name="description"
          content="Check out our latest private health insurance offers including deals on hospital cover and a variety of optional extras to suit your needs. Buy online today."
        />
      </Head>
      {!isEmpty(activeOffers) && (
        <BorderGridContainer hideBorderTop>
          <GridBox padding="0">
            <OfferTile
              placeholders={placeholders}
              overrideOffers={activeOffers}
              heading="Check out our offers"
              variant={VARIANT.HEADER}
              isBoxed={false}
            />
          </GridBox>
        </BorderGridContainer>
      )}
      {getContentToRender(tableOfContents)}
      <MeetTheTeam />
    </>
  );
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
  actions: {
    referral: bindActionCreators(ReferralActions, dispatch),
    referrer: bindActionCreators(ReferrerActions, dispatch),
  },
});

export default connect(null, mapDispatchToProps)(Offers);

export { Offers as OffersForTest };
